module.exports = __webpack_public_path__ + "img/bdf8724.gif";